import { Colors } from '@/common/colors/colors';
import ActionButton from '@/common/components/buttons/ActionButton';
import Input from '@/common/components/Input';
import { SearchBarCenter } from '@/common/styles/SearchBars';
import useSearchBox from '../hooks/useSearchBox';

const ProfitabilitySearchBox = ({ handleSearchCallback }) => {
	const hook = useSearchBox({ handleSearchCallback });

	return (
		<SearchBarCenter>
			<div>
				<Input
					name='From date'
					width={180}
					color={Colors.darkBlue}
					inputRef={hook.dateFromRef}
					type='date'
					value={hook.today}
					inputWidth={140}
					hasIncDec
				/>
				<Input
					name='To date'
					width={180}
					color={Colors.darkBlue}
					inputRef={hook.dateToRef}
					type='date'
					value={hook.today}
					inputWidth={140}
					hasIncDec
				/>
			</div>
			<ActionButton text='Search' onClick={(e) => hook.handleSearch(e)} />
		</SearchBarCenter>
	);
};

export default ProfitabilitySearchBox;
